module.exports = __webpack_public_path__ + "static/media/3 headers-03.c264e4d3.png";